import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { ConfirmationService, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { campsenum } from '../../../../../../../models/enums.generated';
import { camps } from '../../../../../../../models/models.generated';
import { SessionManagementApiService } from '../../../../../../../services/api/session-management-api.service';
import { CampsEnumTranslationService } from '../../../../../../../services/camps-enum-translation.service';
import { CampsDetailsFormStateService } from '../../../../camp-details-form-state-service';

@Component({
    selector: 'app-session-basic-info',
    templateUrl: './session-basic-info.component.html',
    styleUrls: ['./session-basic-info.component.scss'],
    standalone: false
})
export class SessionsBasicInfoComponent implements OnInit {
    @Input() public form: UntypedFormGroup;

    constructor(
        public state: CampsDetailsFormStateService,
        private enumTranslator: CampsEnumTranslationService,
        private confirm: ConfirmationService,
        private alert: BayclubsAlertService,
        private translate: TranslateService,
        private api: SessionManagementApiService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {}

    public get sessionDaysForm(): UntypedFormGroup {
        return this.form.controls['sessionDays'] as UntypedFormGroup;
    }

    public edit() {
        this.state.markAsEdited(this.form);
    }

    public remove() {
        this.confirm
            .show(
                this.translate.instant('CampDetails.RemoveConfirmationTitle'),
                this.translate.instant('CampDetails.RemoveConfirmation')
            )
            .subscribe(result => {
                if (result === true) {
                    var request = <camps.SessionRemoveRequest>{ sessionId: this.form.get('id').value };

                    this.api.remove(request).subscribe(x => {
                        if (x.isSuccess) {
                            // this.removeFromArray(form);
                            this.alert.showOperationSuccess();
                            this.state.sessionRemoved.emit(this.form);
                        } else {
                            this.errorTranslate.translateValidationNotifications(x.validationNotification);
                            this.alert.showError(x.validationNotification.errors[0].message);
                        }
                    });
                }
            });
    }

    public get isOtherItemEdited() {
        return this.state.isOtherItemEdited(this.form);
    }

    public translateVariant(value: campsenum.TimeRangeVariantType) {
        return this.enumTranslator.timeVariant(value);
    }

    public get isUnlimited() {
        var capacity = this.form.get('capacity').value;

        return capacity == null || capacity == undefined;
    }
}
